import { CopilotPanelContentBase, CopilotPanelContext } from './copilotBridge';

export class CopilotTrialWelcomeContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.TrialWelcome;

  constructor(public readonly onCreateProjectDocument: () => void) {
    super();
  }
}
